import { Add } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

import { formatUserName } from '@jebel/utils';

import { UserMembershipsList } from 'features/memberships/components';
import { useUserProductMemberships } from 'features/memberships/hooks';
import { useModalState, useUserById } from 'shared/hooks';

import { GrantMembershipModal } from './GrantMembershipModal';
import { Container, Content, Header, Section } from './MemberMembershipsPage.styles';

/**
 * Displays the selected user's memberships.
 */
export function MemberMembershipsPage() {
  const { id } = useParams<{ id: string }>();
  const { user, loading: isUserLoading } = useUserById({ id });

  const {
    data: memberships,
    isLoading: isMembershipsLoading,
    isIdle: isMembershipsIdle,
  } = useUserProductMemberships(user);

  const { show: showGrantModal, open: openGrantModal, close: closeGrantModal } = useModalState();

  const isLoading = isUserLoading || isMembershipsLoading || isMembershipsIdle;

  return (
    <Container>
      <Header>
        <Typography variant="h6">
          {user ? `${formatUserName(user)}'s Memberships` : 'User Memberships'}
        </Typography>
      </Header>

      <Content>
        <Section>
          <Typography>
            View and manage memberships to access exclusive content or features.
          </Typography>

          <UserMembershipsList user={user} memberships={memberships} isLoading={isLoading} />

          <Button
            startIcon={<Add />}
            variant="outlined"
            color="primary"
            disabled={isLoading}
            onClick={openGrantModal}
          >
            Grant Membership
          </Button>
        </Section>
      </Content>

      <GrantMembershipModal open={showGrantModal} user={id} onClose={closeGrantModal} />
    </Container>
  );
}
